export default "__VITE_ASSET__b6255677__"